import { AllowedValuesDTO } from "api";
import { AllowedFormValues } from "types";

export const getAllowedValuesHelper = (
    allowedValues?: AllowedValuesDTO,
): AllowedFormValues => ({
    utilityTypes:
        allowedValues?.utilityTypes?.map((ut) => ({
            name: ut.name,
            id: ut.id,
            unitDescription: ut.unitDescription?.map((ud) => ({
                unit: ud.unit,
                description: ud.description,
            })) || [],
            ghgEmission: ut.ghgEmission,
        })) || [],
    utilitySubtypesMap: allowedValues?.utilitySubtypesMap || {},
    countries: allowedValues?.countries || [],
    frequency: allowedValues?.frequencies || [],
    regions: allowedValues?.regions || [],
    siteTypes: allowedValues?.siteTypes || [],
    statuses: allowedValues?.billStatuses || [],
    uploadTypes: allowedValues?.uploadTypes || [],
    siteStatuses: allowedValues?.siteStatuses || [],
    countryRegions: allowedValues?.countryRegions || [],
    currencies: allowedValues?.currencies || [],
    units: allowedValues?.units || [],
    siteAreaUnits: allowedValues?.siteAreaUnits || [],
});
